import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './organization-account.persistent-addresses.reducer';
import {AvailablePersistentAddresses} from '../../../services/api/account/persistent-addresses/persistent-address.model';

export const loadOrganizationPersistentAddressesFeatureKey = 'organizationPersistentAddresses';
export const getOrganizationPersistentAddressesSelector =
  createFeatureSelector<State>(loadOrganizationPersistentAddressesFeatureKey);

export const getOrganizationPersistentAddresses = createSelector(
  getOrganizationPersistentAddressesSelector,
  (state: State): AvailablePersistentAddresses => state.record
);

export const getOrganizationPersistentAddressesLoaded = createSelector(
  getOrganizationPersistentAddressesSelector,
  (state: State): boolean => state.loaded
);

export const getOrganizationPersistentAddressesLoading = createSelector(
  getOrganizationPersistentAddressesSelector,
  (state: State): boolean => state.loading
);

export const getOrganizationPersistentAddressesError = createSelector(
  getOrganizationPersistentAddressesSelector,
  (state: State): unknown => state.error
);
